<template>
  <div class="fichaje-wrapper" v-if="userData && userData.can_view_working_hours">
      <div class="header">
        <div class="left-section">
          <h1 class="page-title-home">Control Horario</h1>
        </div>

        <div class="right-section">
          <div class="profile-dropdown" @click="toggleProfileMenu">
            <span class="profile-dropdown__text">Mi perfil</span>
            <v-icon class="profile-dropdown__arrow" small>mdi-menu-down</v-icon>
            <div v-if="showProfileMenu" class="profile-dropdown__menu">
              <div class="profile-dropdown__item" @click.stop="goToProfile">Ver perfil</div>
              <div class="profile-dropdown__item" @click.stop="goToSettings">Configuración</div>
            </div>
          </div>
          <button
            @click="reload_view"
            class="btn-primario btn-refresh"
            :disabled="screen_data.ui_loading"
          >
            <v-icon>mdi-refresh</v-icon>
          </button>
        </div>
      </div>
      <hr class="header-separator" />

      <div class="acciones-secundarias">
        <button @click="navigateTo('absences')" class="btn-secundario-1">
          Ausencias
        </button>
        <button @click="navigateTo('history')" class="btn-secundario">
          Historial
        </button>
        <button @click="navigateTo('admin-month')" class="btn-secundario">
          Previsualización mes
        </button>
        <button @click="navigateTo('holidays')" class="btn-secundario">
          Vacaciones
        </button>
        <button v-if="showAdminButton" @click="handleAdminClick" class="btn-secundario">
          Admin
        </button>
      </div>
      <hr class="header-separator-1" />


      <div class="cuerpo-contenido">
        <div class="fichaje-cards-contenedor">
          <div class="fichaje-column">
            <div class="user-status-widget">
              <div class="user-status-name">{{ screen_data.username }}</div>
              <div class="user-status-state">
                <span class="status-indicator" :class="getStatusClass(screen_data.user_estado)"></span>
                {{ getStatusText(screen_data.user_estado) }}
              </div>
            </div>

            <div class="fichaje-card marco-exterior">
              <div class="marco-interior">
              <div class="progress-bar-container">
                <div class="progress-bar-track">
                  <div
                    v-for="(segment, index) in dailyProgress.segments"
                    :key="index"
                    class="progress-bar-segment"
                    :class="{
                      'segment-work': segment.type === 'work' && !dailyProgress.isCompleted,
                      'segment-pause': segment.type === 'pause' && !dailyProgress.isCompleted,
                      'segment-work-completed': segment.type === 'work' && dailyProgress.isCompleted,
                      'segment-pause-completed': segment.type === 'pause' && dailyProgress.isCompleted,
                      'segment-active': segment.active
                    }"
                    :style="{
                      width: segment.width + '%',
                      left: segment.left + '%'
                    }"
                  ></div>
                  <div class="progress-bar-time">
                    {{ formatTime(screen_data.timerCounting) }}
                  </div>
                </div>
              </div>
              <p class="cronometro-label">Cronómetro</p>
              <div class="reloj-digital">
                {{ formatTime(screen_data.timerCounting) }}
              </div>



              <div class="botones-fichaje-row">
                <button
                  v-if="lastClockType === 'pause'"
                  @click="clock_continue"
                  :disabled="screen_data.ui_loading"
                  class="btn-pause-toggle btn-continue-state"
                >
                  <img src="@/assets/play_icon.svg" alt="play" class="play-icon" />
                  <span>Continuar</span>
                </button>
                <button
                  v-else
                  @click="clock_pause"
                  :disabled="screen_data.ui_hide_btn === 'out' || screen_data.ui_loading"
                  class="btn-pause-toggle"
                  :class="{ 'btn-disabled': screen_data.ui_hide_btn === 'out' }"
                >
                  <img src="@/assets/pause.svg" alt="pause" class="pause-icon" />
                  <span>Pausa</span>
                </button> 

                <button
                  v-if="screen_data.ui_hide_btn === 'out'"
                  @click="clock_in"
                  :disabled="screen_data.ui_loading || hasCompletedWorkdayToday"
                  class="btn-fichar-out"
                  :class="{ 'btn-disabled': hasCompletedWorkdayToday }"
                >
                  <span>{{ hasCompletedWorkdayToday ? 'Fichaje completado' : 'Iniciar Fichaje' }}</span>
                </button>

                <button
                  v-else
                  @click="clock_out"
                  :disabled="screen_data.ui_loading || lastClockType === 'pause'"
                  class="btn-fichar-in"
                  :class="{ 'btn-disabled': lastClockType === 'pause' }"
                >
                  <span>Finalizar Fichaje</span>
                </button>
              </div>
            </div>
          </div>

          </div>
          <!-- Fin de fichaje-column -->

          <!-- Columna central con Franjas Horarias -->
          <div class="center-column">
            <div class="tiempo-trabajado-widget">
              <div class="tiempo-trabajado-header">
                <span class="ubicacion-label">Ubicación</span>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <div class="ubicacion-selector" v-bind="attrs" v-on="on">
                      <img :src="ubicacionSeleccionadaIcon" class="ubicacion-icon" />
                      <span class="ubicacion-text">{{ ubicacionSeleccionadaText }}</span>
                      <v-icon small>mdi-chevron-down</v-icon>
                    </div>
                  </template>
                  <v-list dense>
                    <v-list-item
                      v-for="option in ubicacionOptions"
                      :key="option.value"
                      @click="ubicacionSeleccionada = option.value"
                    >
                      <img :src="option.icon" style="width: 18px; height: 18px; margin-right: 8px;" />
                      <span style="font-weight: 700; color: #4F4F4F;">{{ option.text }}</span>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>

              <div class="tiempo-trabajado-body">
                <div class="date-inside-body">
                  <span class="date-text">{{ formattedTodayDate }}</span>
                  <span class="time-text">{{ currentTime }}</span>
                </div>
                <div v-if="simplifiedTimeSlots.length > 0" class="simple-slots">
                  <div
                    v-for="(slot, index) in simplifiedTimeSlots"
                    :key="index"
                    class="simple-slot"
                  >
                    <img
                      :src="slot.type === 'work' ? require('@/assets/work_time.svg') : require('@/assets/break_time.svg')"
                      class="slot-icon"
                    />
                    <span class="simple-slot-time">
                      {{ slot.start }} -
                      <template v-if="slot.isComplete">{{ slot.end }}</template>
                      <template v-else>
                        <span class="slot-now">Ahora</span>
                        <img :src="require('@/assets/radio_button_checked.svg')" class="slot-now-icon" :class="{ 'slot-now-icon-pause': slot.type !== 'work' }" />
                      </template>
                    </span>
                    <span v-if="slot.isComplete" class="simple-slot-duration" :class="{ 'duration-pause': slot.type !== 'work' }">{{ slot.duration }}</span>
                  </div>
                </div>

                <div v-else class="simple-slots-empty">
                  <v-icon size="32" color="#D1D1D1">mdi-clock-outline</v-icon>
                  <span>Sin fichajes</span>
                </div>
              </div>
            </div>
          </div>
          <!-- Fin de columna central -->

          <!-- Columna derecha con mensajes -->
          <div class="right-column">
            <div class="notifications-widget">
              <div class="notifications-header">
                <div class="notifications-title">
                  <v-icon color="#7339B7" left>mdi-bell-outline</v-icon>
                  <span>Mensajes</span>
                </div>
                <button
                  v-if="notifications.length > 0"
                  @click="markAllAsRead"
                  class="btn-mark-all-read"
                >
                  Marcar todas ✓
                </button>
              </div>

              <div class="notifications-body">
                <div v-if="notifications.length > 0" class="notifications-list">
                  <div
                    v-for="notification in notifications"
                    :key="notification.id"
                    class="notification-item"
                    :class="'notification-' + notification.type"
                  >
                    <div class="notification-icon">
                      <span class="notification-dot" :style="{ backgroundColor: getNotificationColor(notification.type) }"></span>
                    </div>
                    <div class="notification-content">
                      <div class="notification-title">{{ notification.title }}</div>
                      <div class="notification-message">{{ notification.message }}</div>
                      <div class="notification-time">{{ notification.time }}</div>
                    </div>
                    <button
                      @click="dismissNotification(notification.id)"
                      class="btn-dismiss"
                    >
                      <v-icon small>mdi-close</v-icon>
                    </button>
                  </div>
                </div>

                <div v-else class="notifications-empty">
                  <v-icon size="48" color="#D1D1D1">mdi-bell-off-outline</v-icon>
                  <p>No tienes mensajes</p>
                </div>
              </div>
            </div>
          </div>
          <!-- Fin de columna derecha -->

        </div>
        <!-- Fin de fichaje-cards-contenedor -->

        <!-- Nueva fila: Historial | Calendario | Horario Semanal -->
        <div class="bottom-widgets-row">

          <!-- WIDGET TIEMPO TRABAJADO (HISTORIAL) - COMENTADO PARA FUTURA ELIMINACIÓN -->
          <!-- <div class="historial-card">
            <div class="historial-header">
              <div class="historial-titulo">
                <v-icon color="#7339B7" left>mdi-history</v-icon>
                <span>Tiempo trabajado</span>
              </div>
            </div>

            <div class="historial-body">
              <div class="historial-switch">
                <div v-if="clockPairs.length" class="historial-lista">
                  <div
                    v-for="pair in clockPairs"
                    :key="pair.id"
                    class="resumen-dia-container"
                  >
                    <span class="resumen-fecha">{{ pair.date }}</span>
                    <div class="resumen-dia-linea">
                      <div class="entrada-info">
                        <AppIcon :src="require('@/modules/working_hours/assets/arrow_forward.svg')" :size="20" class="icono-entrada" />
                        <span class="label">Entrada:</span>
                        <span class="hora">{{ pair.clockIn }}h</span>
                      </div>
                      <v-icon small color="#888" class="separador-flecha">mdi-arrow-right</v-icon>
                      <div class="salida-info">
                        <AppIcon :src="require('@/modules/working_hours/assets/logout.svg')" :size="20" class="icono-salida" />
                        <span class="label">Salida:</span>
                        <span class="hora" :class="{ 'pendiente': pair.isOpen }">
                          {{ pair.clockOut ? pair.clockOut + 'h' : '--:--' }}
                        </span>
                      </div>
                      <div class="separador-vertical"></div>
                      <div class="total-info">
                        <span class="label">Total:</span>
                        <span class="total-valor">{{ pair.totalFormatted }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-else class="mensaje-sin-fichaje">
                  <v-icon size="48" color="#D1D1D1">mdi-clock-alert-outline</v-icon>
                  <p class="mensaje-buenos-dias">¡Buenos días!</p>
                  <p class="mensaje-no-fichado">Aún no has fichado hoy.</p>
                </div>
              </div>
            </div>
          </div> -->
          <!-- FIN WIDGET TIEMPO TRABAJADO (HISTORIAL) -->

          <!-- Widget de Calendario -->
          <!-- <div class="calendar-widget">
            <div class="calendar-header">
              <button @click="previousMonth" class="btn-calendar-nav">
                <v-icon small>mdi-chevron-left</v-icon>
              </button>
              <div class="calendar-title">
                <span class="calendar-month">{{ currentMonthName }}</span>
                <span class="calendar-year">{{ currentYear }}</span>
              </div>
              <button @click="nextMonth" class="btn-calendar-nav">
                <v-icon small>mdi-chevron-right</v-icon>
              </button>
            </div>

            <div class="calendar-body">
              <div class="calendar-weekdays">
                <div v-for="day in weekDays" :key="day" class="calendar-weekday">
                  {{ day }}
                </div>
              </div>

              <div class="calendar-days">
                <div
                  v-for="(day, index) in calendarDays"
                  :key="index"
                  class="calendar-day"
                  :class="{
                    'calendar-day-empty': !day.date,
                    'calendar-day-today': day.isToday,
                    'calendar-day-weekend': day.isWeekend,
                    'calendar-day-vacation': day.isVacation,
                    'calendar-day-absence': day.isAbsence
                  }"
                >
                  <div v-if="day.date" class="calendar-day-content">
                    <span class="calendar-day-number">{{ day.date }}</span>
                    <div class="calendar-day-hours-container">
                      <div v-if="day.hours" class="calendar-day-hours">
                        {{ day.hours }}h
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="calendar-legend">
              <div class="legend-item">
                <span class="legend-color" style="background: #4CAF50;"></span>
                <span class="legend-text">Vacaciones</span>
              </div>
              <div class="legend-item">
                <span class="legend-color" style="background: #FF9800;"></span>
                <span class="legend-text">Ausencias</span>
              </div>
              <div class="legend-item">
                <span class="legend-color" style="background: #7339B7;"></span>
                <span class="legend-text">Día actual</span>
              </div>
            </div>
          </div> -->

          <!-- Widget de Horario Semanal -->
          <!-- <div class="schedule-widget">
            <div class="schedule-header">
              <div class="schedule-title">
                <v-icon color="#7339B7" left>mdi-clock-outline</v-icon>
                <span>Horario Semanal</span>
              </div>
            </div>

            <div class="schedule-body">
              <div v-if="workSchedule && workSchedule.horario_semanal" class="schedule-list">
                <div
                  v-for="(dayData, dayIndex) in weekSchedule"
                  :key="dayIndex"
                  class="schedule-day-item"
                  :class="{ 'schedule-day-today': dayData.isToday }"
                >
                  <div class="schedule-day-name">{{ dayData.label }}</div>
                  <div class="schedule-day-hours" v-if="dayData.hours">
                    <span class="schedule-time">{{ dayData.hours.entrada }}</span>
                    <v-icon small color="#888">mdi-arrow-right</v-icon>
                    <span class="schedule-time">{{ dayData.hours.salida }}</span>
                    <span class="schedule-break">
                      <v-icon x-small color="#FF9800">mdi-silverware-fork-knife</v-icon>
                      {{ dayData.hours.descanso }}min
                    </span>
                  </div>
                  <div class="schedule-day-off" v-else>
                    <span>No laborable</span>
                  </div>
                </div>
              </div>
              <div v-else class="schedule-empty">
                <v-icon size="48" color="#D1D1D1">mdi-clock-alert-outline</v-icon>
                <p>No hay horario configurado</p>
              </div>
            </div>
          </div> -->

        </div>
        <!-- Fin de bottom-widgets-row -->

      </div>
      <!-- Fin de cuerpo-contenido -->

    <update-clock-popup
      v-if="screen_data.update_clock_popup && screen_data.update_clock_popup.showed"
      :key="screen_data.update_clock_popup.clock_to_update ? screen_data.update_clock_popup.clock_to_update.uuid : 'nuevo'"
      :show="screen_data.update_clock_popup.showed"
      :clock="screen_data.update_clock_popup.clock_to_update"
      :errors="screen_data.update_clock_popup.errors"
      @close="close_update_clock_popup"
    />

    <!-- Snackbar de fichaje completado -->
    <v-snackbar
      v-model="showCompletedSnackbar"
      :timeout="3000"
      bottom
      app
      class="snackbar-success"
    >
      <span class="snackbar-success-text">Fichaje finalizado</span>
    </v-snackbar>
    <v-dialog v-model="confirm_clock_out_dialog" max-width="520px" content-class="confirm-dialog-centered">
      <div class="confirm-popup-container">
        <h2 class="confirm-popup-title">¿Seguro que quieres finalizar tu jornada?</h2>
        <p class="confirm-popup-description">
          Aún no has completado tu horario previsto. Si finalizas ahora, no podrás volver a fichar hasta mañana.
        </p>
        <div class="confirm-popup-buttons">
          <button class="confirm-btn-secondary" @click="confirm_clock_out_dialog = false">
            Seguir trabajando
          </button>
          <button class="confirm-btn-primary" @click="executeClockOut">
            Finalizar fichaje
          </button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>


<script>
import { v4 as uuidv4 } from 'uuid';
import { ClockInCommand, ClockOutCommand, ClockPauseCommand, ClockContinueCommand } from '@/modules/working_hours/app/ClockCommand';
import { APIClockInRepository, APIClockOutRepository, APIClockPauseRepository, APIClockContinueRepository, APIUpdateClockLocationCommand } from '@/modules/working_hours/infra/APIClockRepository';
import { APIClockRepository } from '@/modules/working_hours/infra/APIClockRepository';
import { LoadView } from '@/modules/working_hours/app/LoadView';
import { APIUserRepo } from '@/modules/working_hours/infra/APIUserRepo';
import { ApiWorkingHoursContractRepository } from '@/modules/working_hours/infra/ApiWorkingHoursContractRepository';

import { UpdateClockTodayCommand } from "@/modules/working_hours/app/UpdateClockCommand";
import { UpdateClockPopup as UpdateClockPopupDomain } from "@/modules/working_hours/domain/UpdateClockPopup";
import UpdateClockPopup from "@/modules/working_hours/infra/UpdateClockPopup.vue";

import { formatClockType, formatTime, get_today_secs, get_today_pause_secs, buildProgressSegments } from '@/modules/working_hours/domain/Utils';
import { PermissionsService } from '../domain/PermissionsService';
import { mapGetters } from 'vuex';
import { APIAbsenceRepository } from '@/modules/working_hours/infra/APIAbsenceRepository';
import { Absence } from '@/modules/working_hours/domain/Absence';
import { query_dispatcher } from '@/api/client';
import { getNotificationDataApi, markAsReadNotificationApi } from '@/modules/notifications/infrastructure/NotificationUseCase';

export default {
  components: {
    UpdateClockPopup,
  },
  props: {
    companydb_id: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      screen_data: {
        ui_hide_btn: null,
        ui_loading: false,
        saludo: '',
        last_clock: null,
        estado_texto: '',
        timerCounting: 0,
        pauseCounting: 0, // Contador de tiempo en pausa (en segundos)
        today_string: "",
        clocks: [],
        update_clock_popup: null,
        username: "",
        user_estado: "activo",
      },
      clock_in_cmd: null,
      clock_out_cmd: null,
      clock_pause_cmd: null,
      clock_continue_cmd: null,
      loader: null,

      update_clock_cmd: null,

      // Notificaciones reales
      notifications: [],
      ubicacionSeleccionada: 'oficina',
      locationInitialized: false,
      ubicacionOptions: [
        { text: 'Oficina', value: 'oficina', icon: require('@/assets/work_from_office.svg') },
        { text: 'Remoto', value: 'remoto', icon: require('@/assets/work_from_home.svg') }
      ],
      notificationQuery: null,
      markAsReadCommand: null,
      notificationInterval: null,
      timerInterval: null, // Intervalo para actualizar el cronómetro cada segundo
      currentTime: '',
      currentDateStr: new Date().toDateString(), // Para detectar cambio de día
      showProfileMenu: false, // Para el desplegable de Mi perfil

      // Calendario (COMENTADO - widgets desactivados)
      // currentMonth: new Date().getMonth(),
      // currentYear: new Date().getFullYear(),
      // weekDays: ['L', 'M', 'X', 'J', 'V', 'S', 'D'],
      // monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      //              'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      absences: [], // SE MANTIENE - usado en hasActiveBajaToday() y checkAndCloseIndefiniteBaja()
      // monthClocks: [], // Clocks del mes actual para el calendario
      workSchedule: null, // Horario de trabajo del usuario (SE MANTIENE - usado en dailyProgress)

      // Snackbar de fichaje completado
      showCompletedSnackbar: false,
      workdayCompletedShown: false, // Para evitar mostrar el snackbar múltiples veces

      confirm_clock_out_dialog: false,
    };
  },

  computed: {
    lastClockType() {
      // Obtener el tipo del último clock del array de clocks (más reciente)
      if (this.screen_data.clocks && this.screen_data.clocks.length > 0) {
        // Ordenar por timestamp descendente para asegurar que el primero es el más reciente
        const sortedClocks = [...this.screen_data.clocks].sort((a, b) => {
          return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
        });
        console.log('🔍 lastClockType - Primer clock:', sortedClocks[0].type, 'timestamp:', sortedClocks[0].timestamp);
        return sortedClocks[0].type;
      }
      if (this.screen_data.last_clock) {
        console.log('🔍 lastClockType - Usando last_clock:', this.screen_data.last_clock.type);
        return this.screen_data.last_clock.type;
      }
      console.log('🔍 lastClockType - No hay clocks');
      return null;
    },

    ubicacionSeleccionadaText() {
      const option = this.ubicacionOptions.find(o => o.value === this.ubicacionSeleccionada);
      return option ? option.text : '';
    },

    ubicacionSeleccionadaIcon() {
      const option = this.ubicacionOptions.find(o => o.value === this.ubicacionSeleccionada);
      return option ? option.icon : '';
    },

    canPause() {
      // Se puede pausar si está fichado (ui_hide_btn === 'in') y NO está en pausa
      if (this.screen_data.ui_hide_btn !== 'in') {
        console.log('canPause: false - no está fichado (ui_hide_btn !== in)');
        return false;
      }

      const lastType = this.lastClockType;
      console.log('canPause: lastClockType =', lastType);

      if (!lastType) {
        console.log('canPause: true - está fichado pero no hay last clock');
        return true;
      }

      const can = lastType !== 'pause';
      console.log('canPause:', can, '- lastType !== pause');
      return can;
    },

    canContinue() {
      // Se puede continuar solo si el último clock es 'pause'
      const lastType = this.lastClockType;
      console.log('canContinue: lastClockType =', lastType);

      if (!lastType) {
        console.log('canContinue: false - no hay last clock');
        return false;
      }

      const can = lastType === 'pause';
      console.log('canContinue:', can, '- lastType === pause');
      return can;
    },

    hasCompletedWorkdayToday() {
      // Verifica si el usuario ya finalizó su fichaje del día laboral actual
      // El día laboral se reinicia a las 00:00
      const WORKDAY_RESET_HOUR = 0;

      if (!this.screen_data.clocks || this.screen_data.clocks.length === 0) {
        return false;
      }

      // Calcular el inicio del día laboral actual
      const now = new Date();
      let workdayStart;

      if (now.getHours() < WORKDAY_RESET_HOUR) {
        // Si es antes de las 06:00, el día laboral empezó ayer a las 06:00
        workdayStart = new Date(now);
        workdayStart.setDate(workdayStart.getDate() - 1);
        workdayStart.setHours(WORKDAY_RESET_HOUR, 0, 0, 0);
      } else {
        // Si es después de las 06:00, el día laboral empezó hoy a las 06:00
        workdayStart = new Date(now);
        workdayStart.setHours(WORKDAY_RESET_HOUR, 0, 0, 0);
      }

      // Buscar si hay un clock_out desde el inicio del día laboral
      const hasClockOut = this.screen_data.clocks.some(clock => {
        const clockTime = new Date(clock.timestamp);
        return clock.type === 'out' && clockTime >= workdayStart;
      });

      return hasClockOut;
    },

    ...mapGetters({
      userData: 'me/userData',
    }),

    showAdminButton() {
      return PermissionsService.canViewAdminButton(this.userData);
    },

    // Calcula los segundos de trabajo esperados para el día actual según el horario del trabajador
    expectedWorkSecondsToday() {
      // Valor por defecto si no hay horario configurado: 8 horas
      const DEFAULT_WORK_SECONDS = 8 * 60 * 60;

      // Validar que workSchedule está cargado
      if (!this.workSchedule || !this.workSchedule.horario_semanal) {
        return DEFAULT_WORK_SECONDS;
      }

      // Mapeo de día de la semana (0=domingo, 1=lunes, etc.) a clave del horario
      const dayKeys = ['domingo', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
      const today = new Date();
      const dayKey = dayKeys[today.getDay()];

      const horarioDia = this.workSchedule.horario_semanal[dayKey];

      // Si no hay horario para este día (día libre), usar valor por defecto
      if (!horarioDia || !horarioDia.hora_entrada || !horarioDia.hora_salida) {
        return DEFAULT_WORK_SECONDS;
      }

      // Calcular horas de trabajo: hora_salida - hora_entrada
      const entradaParts = horarioDia.hora_entrada.split(':');
      const salidaParts = horarioDia.hora_salida.split(':');

      const entradaH = parseInt(entradaParts[0], 10);
      const entradaM = parseInt(entradaParts[1], 10);
      const salidaH = parseInt(salidaParts[0], 10);
      const salidaM = parseInt(salidaParts[1], 10);

      const entradaMinutos = entradaH * 60 + entradaM;
      const salidaMinutos = salidaH * 60 + salidaM;

      const trabajoMinutos = salidaMinutos - entradaMinutos;

      // Si el resultado es negativo o inválido, usar valor por defecto
      if (trabajoMinutos <= 0) {
        return DEFAULT_WORK_SECONDS;
      }

      const resultado = trabajoMinutos * 60;
      return resultado;
    },

    // COMENTADO - Computed para el calendario (widgets desactivados)
    // currentMonthName() {
    //   return this.monthNames[this.currentMonth];
    // },

    // calendarDays() {
    //   const firstDay = new Date(this.currentYear, this.currentMonth, 1);
    //   const lastDay = new Date(this.currentYear, this.currentMonth + 1, 0);
    //   const daysInMonth = lastDay.getDate();
    //   const startingDayOfWeek = firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1;
    //
    //   const days = [];
    //
    //   // Días vacíos antes del primer día del mes
    //   for (let i = 0; i < startingDayOfWeek; i++) {
    //     days.push({ date: null });
    //   }
    //
    //   // Calcular horas trabajadas por día desde los clocks del mes
    //   const hoursPerDay = {};
    //   this.monthClocks.forEach(clock => {
    //     const clockDate = new Date(clock.timestamp);
    //     if (clockDate.getMonth() === this.currentMonth && clockDate.getFullYear() === this.currentYear) {
    //       const day = clockDate.getDate();
    //       if (!hoursPerDay[day]) {
    //         hoursPerDay[day] = { in: [], out: [], pause: [], continue: [] };
    //       }
    //       hoursPerDay[day][clock.type].push(clockDate);
    //     }
    //   });
    //
    //   // Calcular horas netas por día (considerando pausas)
    //   const netHoursPerDay = {};
    //   Object.keys(hoursPerDay).forEach(day => {
    //     const dayClocks = hoursPerDay[day];
    //     let totalMinutes = 0;
    //
    //     // Ordenar clocks por timestamp
    //     const allClocks = [
    //       ...dayClocks.in.map(t => ({ type: 'in', time: t })),
    //       ...dayClocks.out.map(t => ({ type: 'out', time: t })),
    //       ...dayClocks.pause.map(t => ({ type: 'pause', time: t })),
    //       ...dayClocks.continue.map(t => ({ type: 'continue', time: t }))
    //     ].sort((a, b) => a.time - b.time);
    //
    //     let lastIn = null;
    //     for (const clock of allClocks) {
    //       if (clock.type === 'in' || clock.type === 'continue') {
    //         lastIn = clock.time;
    //       } else if ((clock.type === 'out' || clock.type === 'pause') && lastIn) {
    //         const minutes = (clock.time - lastIn) / (1000 * 60);
    //         totalMinutes += minutes;
    //         lastIn = null;
    //       }
    //     }
    //
    //     netHoursPerDay[day] = Math.round((totalMinutes / 60) * 10) / 10; // Redondear a 1 decimal
    //   });
    //
    //   const today = new Date();
    //   const isCurrentMonth = this.currentMonth === today.getMonth() && this.currentYear === today.getFullYear();
    //
    //   for (let date = 1; date <= daysInMonth; date++) {
    //     const currentDate = new Date(this.currentYear, this.currentMonth, date);
    //     const dayOfWeek = currentDate.getDay();
    //     const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
    //     const isToday = isCurrentMonth && date === today.getDate();
    //
    //     // Verificar ausencias y vacaciones reales
    //     // Usar UTC para evitar problemas de zona horaria (desplazamiento de días)
    //     const dateStr = `${this.currentYear}-${String(this.currentMonth + 1).padStart(2, '0')}-${String(date).padStart(2, '0')}`;
    //     let isVacation = false;
    //     let isAbsence = false;
    //
    //     this.absences.forEach(absence => {
    //       // Extraer solo la parte de fecha (YYYY-MM-DD) sin conversión de timezone
    //       const absenceStart = absence.start.split('T')[0];
    //       const absenceEnd = absence.end.split('T')[0];
    //
    //       if (dateStr >= absenceStart && dateStr <= absenceEnd) {
    //         if (absence.tipoAusencia === 'Vacaciones') {
    //           isVacation = true;
    //         } else {
    //           isAbsence = true;
    //         }
    //       }
    //     });
    //
    //     const hours = netHoursPerDay[date] || null;
    //
    //     // Calcular horas esperadas según el horario del usuario
    //     let expectedHours = null;
    //     if (this.workSchedule && this.workSchedule.horario_semanal && !isVacation && !isAbsence) {
    //       const diasSemana = ['domingo', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
    //       const nombreDia = diasSemana[dayOfWeek];
    //       const horarioDia = this.workSchedule.horario_semanal[nombreDia];
    //
    //       if (horarioDia && horarioDia.hora_entrada && horarioDia.hora_salida) {
    //         const [horaIn, minIn] = horarioDia.hora_entrada.split(':').map(Number);
    //         const [horaOut, minOut] = horarioDia.hora_salida.split(':').map(Number);
    //         const descanso = horarioDia.descanso || 0;
    //         const minutosDelDia = (horaOut * 60 + minOut) - (horaIn * 60 + minIn) - descanso;
    //         expectedHours = Math.round((minutosDelDia / 60) * 10) / 10; // Redondear a 1 decimal
    //       }
    //     }
    //
    //     days.push({
    //       date,
    //       isToday,
    //       isWeekend,
    //       isVacation,
    //       isAbsence,
    //       hours,
    //       expectedHours
    //     });
    //   }
    //
    //   return days;
    // },

    // weekSchedule() {
    //   if (!this.workSchedule || !this.workSchedule.horario_semanal) {
    //     return [];
    //   }
    //
    //   const daysOfWeek = [
    //     { key: 'lunes', label: 'Lunes' },
    //     { key: 'martes', label: 'Martes' },
    //     { key: 'miercoles', label: 'Miércoles' },
    //     { key: 'jueves', label: 'Jueves' },
    //     { key: 'viernes', label: 'Viernes' },
    //     { key: 'sabado', label: 'Sábado' },
    //     { key: 'domingo', label: 'Domingo' }
    //   ];
    //
    //   const today = new Date();
    //   const todayIndex = today.getDay(); // 0 = domingo, 1 = lunes, etc.
    //   // Convertir a índice donde lunes = 0
    //   const adjustedTodayIndex = todayIndex === 0 ? 6 : todayIndex - 1;
    //
    //   return daysOfWeek.map((day, index) => {
    //     const horario = this.workSchedule.horario_semanal[day.key];
    //     return {
    //       label: day.label,
    //       hours: horario && horario.hora_entrada && horario.hora_salida ? {
    //         entrada: horario.hora_entrada,
    //         salida: horario.hora_salida,
    //         descanso: horario.descanso !== undefined ? horario.descanso : 60  // Por defecto 60 min si no existe
    //       } : null,
    //       isToday: index === adjustedTodayIndex
    //     };
    //   });
    // },

    // Crea segmentos cronológicos de trabajo y pausa
    dailyProgress() {
      // Usar el horario configurado del trabajador para este día
      const expectedSeconds = this.expectedWorkSecondsToday || (8 * 60 * 60); // Fallback a 8h

      const segments = buildProgressSegments(this.screen_data.clocks || [], expectedSeconds);

      // Calcular totales
      const workedMinutes = Math.floor(this.screen_data.timerCounting / 60);
      const pauseMinutes = Math.floor(this.screen_data.pauseCounting / 60);
      const expectedMinutes = Math.floor(expectedSeconds / 60);
      const totalPercentage = Math.min(((this.screen_data.timerCounting + this.screen_data.pauseCounting) / expectedSeconds) * 100, 100);

      const formatMinutesToTime = (mins) => {
        const hours = Math.floor(mins / 60);
        const minutes = mins % 60;
        return `${hours}h ${minutes}min`;
      };

      // Comprobar si se ha termiando la jornada laboral (solo tiempo trabajado, no pausas)
      const isCompleted = expectedSeconds > 0 && this.screen_data.timerCounting >= expectedSeconds;

      return {
        segments,
        percentage: totalPercentage,
        workPercentage: (this.screen_data.timerCounting / expectedSeconds) * 100,
        pausePercentage: (this.screen_data.pauseCounting / expectedSeconds) * 100,
        workedMinutes,
        pauseMinutes,
        expectedMinutes,
        workedFormatted: formatMinutesToTime(workedMinutes),
        pauseFormatted: formatMinutesToTime(pauseMinutes),
        expectedFormatted: expectedMinutes > 0 ? formatMinutesToTime(expectedMinutes) : '--',
        isCompleted: isCompleted
      };
    },

    // WIDGET TIEMPO TRABAJADO (HISTORIAL) - COMENTADO PARA FUTURA ELIMINACIÓN
    // clockPairs() {
    //   if (!this.screen_data.clocks || this.screen_data.clocks.length === 0) {
    //     return [];
    //   }

    //   // Ordenar por timestamp ascendente
    //   const sortedClocks = [...this.screen_data.clocks].sort((a, b) =>
    //     new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
    //   );

    //   const pairs = [];
    //   let entryClockIn = null;
    //   let totalWorkedMinutes = 0;
    //   let lastWorkStart = null;
    //   let isInWorkCycle = false;  // Para rastrear si estamos en un ciclo de trabajo

    //   for (const clock of sortedClocks) {
    //     if (clock.type === 'in') {
    //       // Solo resetear si NO estamos ya en un ciclo de trabajo o si ya había un 'out'
    //       if (!isInWorkCycle) {
    //         entryClockIn = clock;
    //         lastWorkStart = new Date(clock.timestamp);
    //         totalWorkedMinutes = 0;
    //         isInWorkCycle = true;
    //       }
    //     }
    //     else if (clock.type === 'continue') {
    //       // Continuar después de pausa: marcar inicio de trabajo
    //       lastWorkStart = new Date(clock.timestamp);
    //     }
    //     else if (clock.type === 'pause' && lastWorkStart) {
    //       // Pausa: sumar tiempo trabajado desde el último inicio, pero NO crear registro
    //       const pauseTime = new Date(clock.timestamp);
    //       totalWorkedMinutes += Math.floor((pauseTime - lastWorkStart) / (1000 * 60));
    //       lastWorkStart = null;  // Ya no está trabajando activamente
    //     }
    //     else if (clock.type === 'out' && entryClockIn) {
    //       // Salida: crear el registro completo
    //       const outTime = new Date(clock.timestamp);

    //       // Si estaba trabajando (no en pausa), sumar el tiempo hasta la salida
    //       if (lastWorkStart) {
    //         totalWorkedMinutes += Math.floor((outTime - lastWorkStart) / (1000 * 60));
    //       }

    //       const startTime = new Date(entryClockIn.timestamp);
    //       pairs.push({
    //         id: entryClockIn.uuid + '-' + clock.uuid,
    //         clockIn: startTime.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' }),
    //         clockOut: outTime.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' }),
    //         totalFormatted: this.formatMinutes(totalWorkedMinutes),
    //         date: this.screen_data.today_string,
    //         isOpen: false
    //       });

    //       // Resetear para el siguiente ciclo
    //       entryClockIn = null;
    //       lastWorkStart = null;
    //       totalWorkedMinutes = 0;
    //       isInWorkCycle = false;  // Fin del ciclo de trabajo
    //     }
    //   }

    //   // Si hay una entrada sin salida (trabajo en curso o en pausa)
    //   if (entryClockIn) {
    //     const startTime = new Date(entryClockIn.timestamp);
    //     let currentTotalMinutes = totalWorkedMinutes;

    //     // Si está trabajando activamente (no en pausa), sumar tiempo hasta ahora
    //     if (lastWorkStart) {
    //       const now = new Date();
    //       currentTotalMinutes += Math.floor((now - lastWorkStart) / (1000 * 60));
    //     }

    //     pairs.push({
    //       id: entryClockIn.uuid + '-open',
    //       clockIn: startTime.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' }),
    //       clockOut: null,
    //       totalFormatted: this.formatMinutes(currentTotalMinutes),
    //       date: this.screen_data.today_string,
    //       isOpen: true
    //     });
    //   }

    //   return pairs;
    // },
    // FIN WIDGET TIEMPO TRABAJADO (HISTORIAL)

    // Franjas horarias del día para el widget central
    timeSlots() {
      if (!this.screen_data.clocks || this.screen_data.clocks.length === 0) {
        return [];
      }

      // Ordenar por timestamp ascendente
      const sortedClocks = [...this.screen_data.clocks].sort((a, b) =>
        new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
      );

      const slots = [];

      for (let i = 0; i < sortedClocks.length; i++) {
        const clock = sortedClocks[i];
        const nextClock = sortedClocks[i + 1];
        const time = new Date(clock.timestamp).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });

        if (clock.type === 'in') {
          // Entrada - inicio de trabajo
          const endTime = nextClock
            ? new Date(nextClock.timestamp).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })
            : 'En curso';
          const slotType = nextClock && nextClock.type === 'pause' ? 'work' : (nextClock && nextClock.type === 'out' ? 'work' : 'work-active');
          slots.push({
            id: clock.uuid,
            type: slotType,
            icon: 'mdi-login',
            label: 'Entrada',
            startTime: time,
            endTime: endTime,
            isActive: !nextClock || (nextClock.type !== 'pause' && nextClock.type !== 'out')
          });
        } else if (clock.type === 'pause') {
          // Pausa
          const endTime = nextClock && nextClock.type === 'continue'
            ? new Date(nextClock.timestamp).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })
            : 'En pausa';
          slots.push({
            id: clock.uuid,
            type: nextClock && nextClock.type === 'continue' ? 'pause' : 'pause-active',
            icon: 'mdi-coffee',
            label: 'Pausa',
            startTime: time,
            endTime: endTime,
            isActive: !nextClock || nextClock.type !== 'continue'
          });
        } else if (clock.type === 'continue') {
          // Vuelta al trabajo después de pausa
          const endTime = nextClock
            ? new Date(nextClock.timestamp).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })
            : 'En curso';
          const slotType = nextClock && (nextClock.type === 'pause' || nextClock.type === 'out') ? 'work' : 'work-active';
          slots.push({
            id: clock.uuid,
            type: slotType,
            icon: 'mdi-play',
            label: 'Continuar',
            startTime: time,
            endTime: endTime,
            isActive: !nextClock || (nextClock.type !== 'pause' && nextClock.type !== 'out')
          });
        } else if (clock.type === 'out') {
          // Salida - solo mostrar la hora final
          slots.push({
            id: clock.uuid,
            type: 'out',
            icon: 'mdi-logout',
            label: 'Salida',
            startTime: time,
            endTime: null,
            isActive: false
          });
        }
      }

      return slots;
    },

    // Franjas horarias simplificadas: solo icono + rango de horas + duración
    simplifiedTimeSlots() {
      if (!this.screen_data.clocks || this.screen_data.clocks.length === 0) {
        return [];
      }

      const sortedClocks = [...this.screen_data.clocks].sort((a, b) =>
        new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
      );

      const slots = [];
      const formatTime = (date) => date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
      const calcDuration = (start, end) => {
        const diffMs = end - start;
        const totalMinutes = Math.floor(diffMs / (1000 * 60));
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        if (hours > 0 && minutes > 0) return `${hours}h ${minutes}min`;
        if (hours > 0) return `${hours}h`;
        return `${minutes}min`;
      };

      let workStart = null;

      for (let i = 0; i < sortedClocks.length; i++) {
        const clock = sortedClocks[i];
        const time = new Date(clock.timestamp);

        if (clock.type === 'in' || clock.type === 'continue') {
          workStart = time;
        } else if (clock.type === 'pause' && workStart) {
          // Franja de trabajo: desde entrada/continue hasta pausa
          slots.push({
            type: 'work',
            start: formatTime(workStart),
            end: formatTime(time),
            duration: calcDuration(workStart, time),
            isComplete: true
          });
          // Inicio de pausa
          const pauseStart = time;
          const nextClock = sortedClocks[i + 1];
          if (nextClock && nextClock.type === 'continue') {
            // Franja de pausa: desde pausa hasta continue
            const pauseEnd = new Date(nextClock.timestamp);
            slots.push({
              type: 'pause',
              start: formatTime(pauseStart),
              end: formatTime(pauseEnd),
              duration: calcDuration(pauseStart, pauseEnd),
              isComplete: true
            });
          } else {
            // Pausa en curso
            slots.push({
              type: 'pause',
              start: formatTime(pauseStart),
              end: '--:--',
              duration: null,
              isComplete: false
            });
          }
          workStart = null;
        } else if (clock.type === 'out' && workStart) {
          // Franja de trabajo: desde continue hasta salida
          slots.push({
            type: 'work',
            start: formatTime(workStart),
            end: formatTime(time),
            duration: calcDuration(workStart, time),
            isComplete: true
          });
          workStart = null;
        }
      }

      // Si hay trabajo en curso (sin pausa ni salida)
      if (workStart) {
        slots.push({
          type: 'work',
          start: formatTime(workStart),
          end: '--:--',
          duration: null,
          isComplete: false
        });
      }

      return slots;
    },

    // Fecha formateada: "Lunes, 19 de enero"
    formattedTodayDate() {
      const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
      const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
      const now = new Date();
      const dayName = days[now.getDay()];
      const dayNum = now.getDate();
      const monthName = months[now.getMonth()];
      return `${dayName}, ${dayNum} de ${monthName}`;
    },

    // Hora actual formateada
    currentTimeDisplay() {
      const now = new Date();
      return now.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    },
  },

  async created() {
    // Get user from store
    const authenticatedUser = this.$store.getters['me/userData'];
    const companyId = this.companydb_id || (this.$store.state.me && this.$store.state.me.selectedCompanyId);

    // Verify if the user has an active contract, redirect if not
    const hasContract = await this.verifyContractOrRedirect(companyId);
    if (!hasContract) {
      return;
    }

    const repo = new APIClockRepository();
    const repo_in = new APIClockInRepository();
    const repo_out = new APIClockOutRepository();
    const repo_pause = new APIClockPauseRepository();
    const repo_continue = new APIClockContinueRepository();
    const user_repo = new APIUserRepo(this.$store);

    let timer = {'t':null}

    this.loader = new LoadView(repo, this.screen_data, timer, 1, user_repo, authenticatedUser);
    
    await Promise.all([
      this.loader.load(),
      this.loadWorkSchedule()
    ]);

    this.clock_in_cmd = new ClockInCommand(repo_in, this.screen_data, 5000, 1000,timer);
    this.clock_out_cmd = new ClockOutCommand(repo_out, this.screen_data, 5000, 1000,timer );
    this.clock_pause_cmd = new ClockPauseCommand(repo_pause, this.screen_data, 5000, 1000,timer);
    this.clock_continue_cmd = new ClockContinueCommand(repo_continue, this.screen_data, 5000, 1000,timer);

    this.screen_data.update_clock_popup = new UpdateClockPopupDomain();
    this.update_clock_cmd = new UpdateClockTodayCommand(repo, this.screen_data);

    // Inicializar queries y commands de notificaciones
    this.notificationQuery = getNotificationDataApi();
    this.markAsReadCommand = markAsReadNotificationApi();

    // Cargar notificaciones
    await this.loadNotifications();

    // Verificar si debería mostrar notificación de fichaje olvidado
    this.checkMissingClockNotification();

    // Actualizar el estado del usuario basado en el último clock
    this.updateUserStatus();

    // Inicializar ubicación basándose en el último clock
    this.initializeLocationFromLastClock();

    // Inicializar contadores desde los clocks existentes
    this.updateTimerCounting();
    this.updatePauseCounting();

    // Configurar recarga periódica de notificaciones cada 5 minutos
    this.notificationInterval = setInterval(() => {
      this.loadNotifications();
    }, 5 * 60 * 1000); // 5 minutos

    // Inicializar la hora actual
    this.updateCurrentTime();

    // Configurar intervalo para actualizar el cronómetro cada segundo (barra de progreso dinámica)
    this.timerInterval = setInterval(() => {
      // Actualizar la hora del reloj
      this.updateCurrentTime();

    
      const nowDateStr = new Date().toDateString();
      if (nowDateStr !== this.currentDateStr) {
        this.currentDateStr = nowDateStr;
        console.log('Cambio de día detectado, recargando datos...');
        this.reload_view();
        return;
      }

      const currentLastClockType = this.lastClockType;

      if (currentLastClockType === 'in' || currentLastClockType === 'continue' || currentLastClockType === 'pause') {
        this.screen_data.timerCounting = get_today_secs(this.screen_data.clocks);
        this.screen_data.pauseCounting = get_today_pause_secs(this.screen_data.clocks);
      }
      // Si lastClockType es 'out' o null, no recalcular (ya está fijo)
    }, 1000);

    // Si el fichaje ya estaba completado al cargar la página, marcar como ya mostrado
    // para no mostrar el snackbar innecesariamente
    if (this.dailyProgress && this.dailyProgress.isCompleted) {
      this.workdayCompletedShown = true;
    }
  },

  beforeDestroy() {
    // Limpiar los intervalos cuando el componente se destruya
    if (this.notificationInterval) {
      clearInterval(this.notificationInterval);
    }
    this.stopAllTimers();
  },

  methods: {
    updateCurrentTime() {
      const now = new Date();
      this.currentTime = now.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    },

    getCompanyId() {
      return this.companydb_id || this.$route.params.companydb_id || (this.userData && this.userData.company_id) || '1';
    },

    formatMinutes(totalMinutes) {
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      if (hours > 0 && minutes > 0) {
        return `${hours}h ${minutes}min`;
      } else if (hours > 0) {
        return `${hours}h`;
      } else {
        return `${minutes}min`;
      }
    },

    navigateToHome() {
      const companyId = this.getCompanyId();
      var result = this.$router.push(`/${companyId}`);
      if (result && result.catch) {
        result.catch(function() {});
      }
    },

    navigateTo(section) {
      const companyId = this.getCompanyId();
      const routes = {
        'absences': `/${companyId}/working-hours-absences`,
        'holidays': `/${companyId}/working-hours-holidays`,
        'history': `/${companyId}/working-hours-history`,
        'admin-month': `/${companyId}/working-hours-admin-month`,
        'admin-users': `/${companyId}/working-hours-admin-users`
      };
      var result = this.$router.push(routes[section]);
      if (result && result.catch) {
        result.catch(function() {});
      }
    },

    toggleProfileMenu() {
      this.showProfileMenu = !this.showProfileMenu;
    },

    goToProfile() {
      this.showProfileMenu = false;
      // Navegar al perfil del usuario
      this.$router.push('/profile').catch(() => {});
    },

    goToSettings() {
      this.showProfileMenu = false;
      // Navegar a configuración
      this.$router.push('/settings').catch(() => {});
    },

    updateTimerCounting() {
      this.screen_data.timerCounting = get_today_secs(this.screen_data.clocks);
    },

    updatePauseCounting() {
      this.screen_data.pauseCounting = get_today_pause_secs(this.screen_data.clocks);
    },

    hasActiveBajaToday() {
      // NOTA: Si absences no está cargado (widget calendario desactivado), retornar false
      if (!this.absences || this.absences.length === 0) {
        return false;
      }

      // Verificar si hay una baja activa y aprobada en el día de hoy
      const today = new Date();
      const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

      return this.absences.some(absence => {
        // Solo considerar bajas (tipos que empiezan con "Baja:")
        if (!absence.tipoAusencia || !absence.tipoAusencia.startsWith('Baja:')) {
          return false;
        }

        // Solo considerar bajas aprobadas
        if (absence.status !== 'approved') {
          return false;
        }

        // Verificar si hoy está dentro del rango de la baja
        const absenceStart = absence.start.split('T')[0];
        const absenceEnd = absence.end.split('T')[0];

        return todayStr >= absenceStart && todayStr <= absenceEnd;
      });
    },

    updateUserStatus() {
      const lastType = this.lastClockType;
      console.log('🔄 Actualizando estado del usuario. Último clock:', lastType);

      // Primero verificar si hay una baja activa y aprobada hoy
      if (this.hasActiveBajaToday()) {
        this.screen_data.user_estado = "baja";
        console.log('✅ Estado actualizado a: baja (baja activa detectada)');
        return;
      }

      if (!lastType) {
        this.screen_data.user_estado = "inactivo";
        return;
      }

      switch(lastType) {
        case 'in':
        case 'continue':
          this.screen_data.user_estado = "activo";
          break;
        case 'out':
          this.screen_data.user_estado = "inactivo";
          break;
        case 'pause':
          this.screen_data.user_estado = "pausa";
          break;
        default:
          this.screen_data.user_estado = "inactivo";
      }

      console.log('✅ Estado actualizado a:', this.screen_data.user_estado);
    },

    initializeLocationFromLastClock() {
      // Inicializar ubicacionSeleccionada basándose en el último clock
      if (this.screen_data.last_clock && this.screen_data.last_clock.location) {
        const location = this.screen_data.last_clock.location;
        // Mapear 'office' -> 'oficina', 'remote' -> 'remoto'
        this.ubicacionSeleccionada = location === 'remote' ? 'remoto' : 'oficina';
        console.log('📍 Ubicación inicializada desde último clock:', this.ubicacionSeleccionada);
      }
      // Marcar como inicializado para que el watcher pueda enviar cambios
      this.$nextTick(() => {
        this.locationInitialized = true;
      });
    },

    async checkAndCloseIndefiniteBaja() {
      // NOTA: Funcionalidad desactivada temporalmente - widget de calendario comentado
      // Si no hay absences cargadas, no hacer nada
      if (!this.absences || this.absences.length === 0) {
        return;
      }

      // Verificar si hay una baja indefinida activa y cerrarla al día anterior
      const today = new Date();
      const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

      // Buscar bajas indefinidas activas (tipos específicos + fecha fin lejana)
      const indefinidaBaja = this.absences.find(absence => {
        // Solo considerar bajas
        if (!absence.tipoAusencia || !absence.tipoAusencia.startsWith('Baja:')) {
          return false;
        }

        // Solo considerar tipos indefinidos
        const isIndefinida =
          absence.tipoAusencia.includes('Cumplimiento deber inexcusable') ||
          absence.tipoAusencia.includes('Funciones sindicales') ||
          absence.tipoAusencia.includes('Nacimiento y cuidado del menor') ||
          absence.tipoAusencia.includes('Donación de órganos');

        if (!isIndefinida) {
          return false;
        }

        // Verificar que la baja esté activa (incluya el día de hoy)
        const absenceStart = absence.start.split('T')[0];
        const absenceEnd = absence.end.split('T')[0];

        return todayStr >= absenceStart && todayStr <= absenceEnd;
      });

      if (indefinidaBaja) {
        try {
          // Calcular el día anterior
          const yesterday = new Date(today);
          yesterday.setDate(yesterday.getDate() - 1);
          yesterday.setHours(23, 59, 59, 999);

          // Actualizar la fecha fin de la baja
          const updatedAbsence = new Absence(
            indefinidaBaja.uuid,
            indefinidaBaja.start,
            yesterday.toISOString(),
            indefinidaBaja.reason,
            indefinidaBaja.status,
            indefinidaBaja.fotoJustificante,
            indefinidaBaja.lista_motivos,
            indefinidaBaja.tipoAusencia
          );

          // Agregar user_id al objeto (necesario para el comando de actualización)
          updatedAbsence.user_id = indefinidaBaja.user_id;

          // Guardar la actualización usando el repositorio
          const absenceRepo = new APIAbsenceRepository();
          await absenceRepo.update(updatedAbsence);

          console.log('✅ Baja indefinida cerrada automáticamente al día anterior');

          // NOTA: loadMonthAbsences() comentado - widget de calendario desactivado
          // await this.loadMonthAbsences();
        } catch (error) {
          console.error('Error cerrando baja indefinida:', error);
          // No bloquear el fichaje si falla la actualización de la baja
        }
      }
    },

    getLocationValue() {
      // Mapear valores del UI a valores del backend
      return this.ubicacionSeleccionada === 'oficina' ? 'office' : 'remote';
    },

    async clock_in() {
      // Verificar y cerrar baja indefinida si existe
      await this.checkAndCloseIndefiniteBaja();

      const previousEstado = this.screen_data.user_estado;
      this.screen_data.user_estado = "activo";
      try {
        await this.clock_in_cmd.execute(new Date(), uuidv4(), this.getLocationValue());
        // Eliminar notificación de fichaje olvidado si existe
        this.notifications = this.notifications.filter(n => !n.id.startsWith('missing-clock-in-'));
        await this.$nextTick();
      } catch (error) {
        this.screen_data.user_estado = previousEstado;
      }
    },

    async clock_out() {
      // Mostrar popup de confirmación
      this.confirm_clock_out_dialog = true;
    },

    async executeClockOut() {
      // Cerrar el popup
      this.confirm_clock_out_dialog = false;
      const previousEstado = this.screen_data.user_estado;
      this.screen_data.user_estado = "inactivo";
      try {
        await this.clock_out_cmd.execute(new Date(), uuidv4(), this.getLocationValue());
        await this.$nextTick();
      } catch (error) {
        this.screen_data.user_estado = previousEstado;
      }
    },

    stopAllTimers() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    },

    async clock_pause() {
      const previousEstado = this.screen_data.user_estado;
      this.screen_data.user_estado = "pausa";
      try {
        await this.clock_pause_cmd.execute(new Date(), uuidv4(), this.getLocationValue());
        await this.$nextTick();
      } catch (error) {
        this.screen_data.user_estado = previousEstado;
      }
    },

    async clock_continue() {
      const previousEstado = this.screen_data.user_estado;
      this.screen_data.user_estado = "activo";
      try {
        await this.clock_continue_cmd.execute(new Date(), uuidv4(), this.getLocationValue());
        await this.$nextTick();
      } catch (error) {
        this.screen_data.user_estado = previousEstado;
      }
    },

    async reload_view() {
      await this.loader.load();
      await this.loadWorkSchedule();
      this.updateUserStatus();
      this.updateTimerCounting();
      this.updatePauseCounting();
      // También recargar notificaciones
      await this.loadNotifications();
    },

    async close_update_clock_popup(result) {
      this.screen_data.update_clock_popup.close(result);

      // Si el resultado contiene un clock actualizado, actualizar todos los contadores
      if (result && result.updated_clock) {
        console.log('🔄 Clock actualizado, recargando datos...', result.updated_clock);

        try {
          // Detener temporalmente el intervalo del timer para evitar conflictos
          this.stopAllTimers();

          // Recargar los clocks desde el servidor para tener los datos actualizados
          await this.loader.load();

          // Esperar un tick para que Vue procese los cambios
          await this.$nextTick();

          // Recalcular TODOS los contadores con los nuevos datos
          this.screen_data.timerCounting = get_today_secs(this.screen_data.clocks);
          this.screen_data.pauseCounting = get_today_pause_secs(this.screen_data.clocks);

          // Actualizar el estado del usuario por si cambió
          this.updateUserStatus();

          // Reiniciar el intervalo del timer con detección de cambio de día
          this.timerInterval = setInterval(() => {
            const nowDateStr = new Date().toDateString();
            if (nowDateStr !== this.currentDateStr) {
              this.currentDateStr = nowDateStr;
              this.reload_view();
              return;
            }
            const currentLastClockType = this.lastClockType;
            if (currentLastClockType === 'in' || currentLastClockType === 'continue' || currentLastClockType === 'pause') {
              this.screen_data.timerCounting = get_today_secs(this.screen_data.clocks);
              this.screen_data.pauseCounting = get_today_pause_secs(this.screen_data.clocks);
            }
          }, 1000);

          // Forzar actualización del componente para refrescar la vista
          await this.$nextTick();
        } catch (error) {
          console.error('Error actualizando datos después de modificar clock:', error);
        }
      }
    },

    clocksHaveChanged(newClocks, oldClocks) {
      // Verificar si los arrays tienen diferente longitud
      if (!newClocks || !oldClocks || newClocks.length !== oldClocks.length) {
        return true;
      }

      // Verificar si algún clock cambió su timestamp o tipo
      for (let i = 0; i < newClocks.length; i++) {
        const newClock = newClocks[i];
        const oldClock = oldClocks.find(c => c.uuid === newClock.uuid);

        if (!oldClock) {
          return true; // Nuevo clock añadido
        }

        // Comparar timestamp y tipo
        if (newClock.timestamp !== oldClock.timestamp || newClock.type !== oldClock.type) {
          console.log(`🔄 Clock ${newClock.uuid} cambió:`, {
            oldTime: oldClock.timestamp,
            newTime: newClock.timestamp,
            oldType: oldClock.type,
            newType: newClock.type
          });
          return true;
        }

        // Verificar cambios en el array de changes
        if (newClock.changes && oldClock.changes) {
          if (newClock.changes.length !== oldClock.changes.length) {
            return true;
          }
        }
      }

      return false;
    },

    formatType(type) {
      return formatClockType(type);
    },

    formatTime(type) {
      return formatTime(type);
    },

    handleAdminClick() {
      // Todos (owner, admin, cliente) van a working-hours-admin-users
      this.navigateTo('admin-users');
    },

    getStatusClass(estado) {
      const statusMap = {
        'activo': 'status-activo',
        'pausa': 'status-pausa',
        'inactivo': 'status-inactivo',
        'vacaciones': 'status-vacaciones',
        'baja': 'status-baja'
      };
      return statusMap[estado] || 'status-activo';
    },

    getStatusText(estado) {
      const textMap = {
        'activo': 'Activo',
        'pausa': 'Pausa',
        'inactivo': 'Inactivo',
        'vacaciones': 'Vacaciones',
        'baja': 'Baja'
      };
      return textMap[estado] || 'Activo';
    },

    getSlotIconColor(type) {
      const colorMap = {
        'work': '#7339B7',
        'work-active': '#7339B7',
        'pause': '#FFC107',
        'pause-active': '#FFC107',
        'out': '#4CAF50'
      };
      return colorMap[type] || '#7339B7';
    },

    async verifyContractOrRedirect(companydb_id) {
      // Verify if the user has an active contract
      const contractRepo = new ApiWorkingHoursContractRepository();
      const authenticatedUser = this.$store.getters['me/userData'];
      const contractStatus = await contractRepo.check_user_working_hours_active_contract(authenticatedUser.user, companydb_id);

      // If the user does not have an active contract, redirect to trial
      if (!contractStatus.has_active) {
        this.$router.push({
          name: 'working-hours-trial',
          params: { companydb_id: companydb_id }
        }).catch(() => {});
        return false;
      }

      return true;
    },

    async checkContractAndLoad(companydb_id) {
      // Verify contract, redirect if not active
      const hasContract = await this.verifyContractOrRedirect(companydb_id);
      if (!hasContract) {
        return;
      }

      // Reload the data for the new company
      if (this.loader) {
        await this.loader.load();
      }
    },

    // Métodos para el widget de notificaciones
    checkMissingClockNotification() {
      try {
        // Verificar si tiene horario configurado
        if (!this.workSchedule || !this.workSchedule.horario_semanal) {
          return;
        }

        // Obtener el día de hoy
        const now = new Date();
        const dayNames = ['domingo', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
        const today = dayNames[now.getDay()];

        // Obtener el horario de hoy
        const todaySchedule = this.workSchedule.horario_semanal[today];
        if (!todaySchedule || !todaySchedule.hora_entrada) {
          return;
        }

        // Verificar si ya fichó entrada hoy
        const hasClockIn = this.screen_data.clocks.some(clock => clock.type === 'in');
        if (hasClockIn) {
          return;
        }

        // Calcular si han pasado más de 15 minutos desde la hora de entrada
        const [horaEntrada, minutosEntrada] = todaySchedule.hora_entrada.split(':').map(Number);
        const expectedClockIn = new Date(now.getFullYear(), now.getMonth(), now.getDate(), horaEntrada, minutosEntrada);
        const diffMinutes = (now - expectedClockIn) / 1000 / 60;

        if (diffMinutes > 15) {
          // Agregar notificación al principio del array
          this.notifications.unshift({
            id: 'missing-clock-in-' + Date.now(),
            type: 'warning',
            title: '⏰ Recordatorio de fichaje',
            message: 'Parece que olvidaste fichar tu entrada. Tu hora programada era ' + todaySchedule.hora_entrada + '.',
            time: 'Ahora',
            read: false
          });
        }
      } catch (error) {
        console.error('Error verificando fichaje olvidado:', error);
      }
    },

    async loadNotifications() {
      try {
        const userData = this.$store.getters['me/userData'];
        if (!userData || !userData.id) {
          return;
        }

        const result = await this.notificationQuery.execute();

        // La respuesta puede venir como array directo o como { notifications: [...] }
        const notificationsList = Array.isArray(result) ? result : (result.notifications || []);

        // Mapear las notificaciones del backend al formato del componente
        this.notifications = notificationsList.map((noti) => {
          // Determinar el tipo basándose en el subject
          let type = 'general';
          const subject = (noti.subject || '').toLowerCase();
          if (subject.includes('aprobad') || subject.includes('aprovad')) {
            type = 'success';
          } else if (subject.includes('rechazad') || subject.includes('olvidado') || subject.includes('pendiente')) {
            type = 'warning';
          } else if (subject.includes('recordatorio') || subject.includes('festivo') || subject.includes('información')) {
            type = 'info';
          }

          return {
            id: noti.id,
            type: type,
            title: noti.subject || 'Sin asunto',
            message: noti.message || '',
            time: this.formatNotificationTime(noti.id),
            read: noti.read
          };
        }).filter(n => !n.read); // Solo mostrar no leídas
      } catch (error) {
        console.error('Error cargando notificaciones:', error);
        this.notifications = [];
      }
    },

    formatNotificationTime(notiId) {
      // Por ahora devolvemos un texto genérico
      // Idealmente el backend debería devolver el timestamp
      return 'Reciente';
    },

    getNotificationColor(type) {
      const colors = {
        urgent: '#F44336',    // Rojo
        warning: '#FFC107',   // Amarillo
        success: '#4CAF50',   // Verde
        info: '#2196F3',      // Azul
        general: '#7339B7'    // Morado
      };
      return colors[type] || colors.general;
    },

    async dismissNotification(id) {
      try {
        const userData = this.$store.getters['me/userData'];
        if (!userData || !userData.id) return;

        // Marcar como leída en el backend
        await this.markAsReadCommand.run(userData.id, id);

        // Eliminar de la lista local
        this.notifications = this.notifications.filter(n => n.id !== id);
      } catch (error) {
        console.error('Error marcando notificación como leída:', error);
      }
    },

    async markAllAsRead() {
      try {
        const userData = this.$store.getters['me/userData'];
        if (!userData || !userData.id) return;

        // Marcar todas como leídas
        for (const noti of this.notifications) {
          await this.markAsReadCommand.run(userData.id, noti.id);
        }

        // Limpiar la lista local
        this.notifications = [];
      } catch (error) {
        console.error('Error marcando todas las notificaciones como leídas:', error);
      }
    },

    // COMENTADO - Métodos para el calendario (widgets desactivados)
    // async loadCalendarData() {
    //   await Promise.all([
    //     this.loadMonthAbsences(),
    //     this.loadMonthClocks(),
    //     this.loadWorkSchedule()
    //   ]);
    // },

    // SE MANTIENE - usado en dailyProgress para calcular el porcentaje de progreso
    async loadWorkSchedule() {
      try {
        const userData = this.$store.getters['me/userData'];

        const result = await query_dispatcher.dispatch("get_work_schedule_by_user.query", {
          user_id: userData.id
        });

        this.workSchedule = result || null;
      } catch (error) {
        console.error('Error cargando horario de trabajo:', error);
        this.workSchedule = null;
      }
    },

    // COMENTADO - solo usado por calendario
    // async loadMonthAbsences() {
    //   try {
    //     const userData = this.$store.getters['me/userData'];
    //     if (!userData || !userData.id) return;
    //
    //     const result = await query_dispatcher.dispatch("AbsenceByUserQuery", {
    //       user_id: userData.id
    //     });
    //
    //     // Filtrar ausencias del mes actual (o que se solapen)
    //     const firstDay = new Date(this.currentYear, this.currentMonth, 1);
    //     const lastDay = new Date(this.currentYear, this.currentMonth + 1, 0);
    //
    //     this.absences = result.filter(a => {
    //       const start = new Date(a.start);
    //       const end = new Date(a.end);
    //       // Incluir si se solapa con el mes actual
    //       return (start <= lastDay && end >= firstDay);
    //     });
    //   } catch (error) {
    //     console.error('Error cargando ausencias:', error);
    //     this.absences = [];
    //   }
    // },

    // COMENTADO - solo usado por calendario
    // async loadMonthClocks() {
    //   try {
    //     const userData = this.$store.getters['me/userData'];
    //     if (!userData || !userData.id) return;
    //
    //     const firstDay = new Date(this.currentYear, this.currentMonth, 1);
    //     const lastDay = new Date(this.currentYear, this.currentMonth + 1, 0);
    //
    //     // Formatear fechas en formato YYYY-MM-DD
    //     const startDate = firstDay.toISOString().split('T')[0];
    //     const endDate = lastDay.toISOString().split('T')[0];
    //
    //     const result = await query_dispatcher.dispatch("filter_clocks.query", {
    //       user_id: userData.id,
    //       filters: [
    //         ['timestamp', '>=', startDate],
    //         ['timestamp', '<=', endDate]
    //       ],
    //       order_by: ['timestamp'],
    //       powerOrNot: false
    //     });
    //
    //     this.monthClocks = result || [];
    //   } catch (error) {
    //     console.error('Error cargando clocks del mes:', error);
    //     this.monthClocks = [];
    //   }
    // },

    // COMENTADO - solo usado por calendario
    // async previousMonth() {
    //   if (this.currentMonth === 0) {
    //     this.currentMonth = 11;
    //     this.currentYear--;
    //   } else {
    //     this.currentMonth--;
    //   }
    //   await this.loadCalendarData();
    // },

    // COMENTADO - solo usado por calendario
    // async nextMonth() {
    //   if (this.currentMonth === 11) {
    //     this.currentMonth = 0;
    //     this.currentYear++;
    //   } else {
    //     this.currentMonth++;
    //   }
    //   await this.loadCalendarData();
    // },
  },

  watch: {
    // Observar cambios en ubicación seleccionada para actualizar el último fichaje
    async ubicacionSeleccionada(newLocation) {
      // No enviar al servidor si aún no se ha inicializado (evitar llamada durante carga inicial)
      if (!this.locationInitialized) {
        return;
      }
      const userData = this.$store.getters['me/userData'];
      if (userData && userData.id) {
        try {
          const updateLocationCmd = new APIUpdateClockLocationCommand();
          await updateLocationCmd.execute(userData.id, this.getLocationValue());
        } catch (error) {
          console.error('Error actualizando ubicación:', error);
        }
      }
    },

    // Observar cambios en los clocks para recalcular los contadores
    'screen_data.clocks': {
      handler(newClocks, oldClocks) {
        // Solo recalcular si realmente cambiaron los clocks (no solo el orden)
        if (this.clocksHaveChanged(newClocks, oldClocks)) {
          console.log('📊 Clocks cambiaron, recalculando contadores...');

          // Recalcular ambos contadores
          this.screen_data.timerCounting = get_today_secs(this.screen_data.clocks);
          this.screen_data.pauseCounting = get_today_pause_secs(this.screen_data.clocks);

          console.log('✅ Contadores actualizados:');
          console.log('   - Trabajo:', this.formatTime(this.screen_data.timerCounting));
          console.log('   - Pausas:', this.formatTime(this.screen_data.pauseCounting));
          console.log('   - Total:', this.formatTime(this.screen_data.timerCounting + this.screen_data.pauseCounting));
        }
      },
      deep: true
    },

    // Observar cuando el fichaje se completa para mostrar el snackbar
    'dailyProgress.isCompleted': {
      handler(isCompleted) {
        if (isCompleted && !this.workdayCompletedShown) {
          this.showCompletedSnackbar = true;
          this.workdayCompletedShown = true;
        }
      },
      immediate: false
    },

    async '$route.params.companydb_id'(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        await this.checkContractAndLoad(newVal);
      }
    },

    // Watch para cambios desde el store (cuando se selecciona empresa en el selector)
    '$store.state.currentCompany': {
      async handler(newCompany, oldCompany) {
        if (newCompany && oldCompany && newCompany.id !== oldCompany.id) {
          // Redirigir a la nueva ruta con el nuevo companydb_id
          await this.$router.push({
            name: 'working-hours',
            params: { companydb_id: newCompany.id }
          }).catch(() => {});
        }
      },
      deep: true
    }
  },
}
</script>

<style scoped>
.fichaje-wrapper {
  background-color: #FFFFFF;
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-radius: 20px 20px 0 0;
  height: calc(100vh - 95px);
  overflow-y: auto;
  position: relative;
  z-index: 0;
  isolation: isolate;
}

.fichaje-card {
  flex: none;
  height: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: 20px;
  background: #FFFFFF;
}

.nombre-usuario {
  color: var(--Neutral-400, #888);
  text-align: center;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: var(--Static-Title-Large-Line-Height, 28px);
  letter-spacing: var(--Static-Title-Large-Tracking, 0px);
}

.cronometro-label {
  color: hsl(0, 0%, 53%);
  font-size: 13px;
  font-weight: 600;
  margin: 0 0 -22px 0;
}

.reloj-digital {
  color: #454545;
  font-family: var(--sds-typography-subheading-font-family);
  font-size: 30px;
  font-style: normal;
  font-weight: 500;
  line-height: 42px;
  letter-spacing: 0.8px;
}

/* Barra de progreso diario */
.progress-bar-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  margin: 10px 0;
  box-sizing: border-box;
}

.progress-bar-track {
  width: 100%;
  height: 24px;
  background: #E7E7E7;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  border: 1px solid #D0D0D0;
  box-sizing: border-box;
}

.progress-bar-segment {
  height: 100%;
  border-radius: 0;
  position: absolute;
  top: 0;
  transition: width 0.3s ease;
}

.segment-work {
  background: #E7DBF9; /* Lavanda claro para tiempo trabajado */
  z-index: 2;
}

.segment-pause {
  background: #FAF9D7; /* Amarillo muy claro para tiempo de pausa */
  z-index: 2;
}

.segment-work-completed {
  background: #7DD985; /* Verde para tiempo trabajado completado */
  z-index: 2;
}

.segment-pause-completed {
  background: #FFFDC5; /* Amarillo claro para tiempo de pausa completado */
  z-index: 2;
}

.segment-active {
  /* El segmento activo (el que está creciendo) puede tener una animación sutil */
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.9;
  }
}

.progress-bar-time {
  position: absolute;
  left: 10px;
  top: 2px;
  bottom: 0;
  display: flex;
  align-items: center;
  font-size: 11px;
  line-height: 1;
  font-weight: 700;
  color: #565656;
  z-index: 10;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);
}

.progress-bar-label {
  font-size: 13px;
  font-weight: 500;
  color: #888;
}

.texto-secundario {
  font-size: 13px;
  color: #565656;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.botones-fichaje-row {
  display: flex;
  flex-direction: row;
  gap: 12px;
  width: 100%;
  padding: 0 12px;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
}

.btn-pause-toggle {
  background: #F9F9F9;
  color: #000000;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex: 0 0 auto;
  width: 125px;
  height: 52px;
  padding: 14px 14px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 400;
  text-transform: none;
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid #454545;
  cursor: pointer;
}

.btn-pause-toggle .pause-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.btn-pause-toggle span {
  flex: 1;
  text-align: center;
}

.btn-pause-toggle:not(.btn-disabled):hover {
  background-color: #F9F9F9;
  transform: translateY(-2px);
}

.btn-pause-toggle.btn-continue-state {
  background-color: #F9F9F9;
}

.btn-pause-toggle.btn-continue-state:hover {
  background-color: #EFEFEF;
}

.btn-fichar-in {
  background: var(--Primary-700, #7339B7);
  color: #F9F6FE;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex: 1;
  height: 52px;
  padding: 14px 28px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 400;
  text-transform: none;
  text-align: center;
  transition: all 0.3s ease;
  white-space: nowrap;
  border: none;
  cursor: pointer;
  position: relative;
}

.btn-fichar-in:hover {
  transform: translateY(-2px);
}

.btn-fichar-in .icono-btn,
.btn-fichar-out .icono-btn {
  position: absolute;
  left: 14px;
}

.btn-fichar-out {
  background: var(--Primary-700, #7339B7);
  color: #F9F6FE;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex: 1;
  height: 52px;
  padding: 14px 28px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 400;
  text-transform: none;
  text-align: center;
  transition: all 0.3s ease;
  white-space: nowrap;
  border: none;
  cursor: pointer;
  position: relative;
}

.btn-fichar-out:hover {
  transform: translateY(-2px);
}

/* Estado disabled para botones - usa selectores específicos para evitar !important */
.fichaje-wrapper button.btn-disabled,
.fichaje-wrapper .btn-disabled {
  background-color: #BDBDBD;
  color: #757575;
  cursor: not-allowed;
  opacity: 0.6;
  box-shadow: none;
  pointer-events: none;
}

.fichaje-wrapper button.btn-disabled:hover,
.fichaje-wrapper .btn-disabled:hover {
  transform: none;
  box-shadow: none;
  background-color: #BDBDBD;
}
.btn-pause-toggle.btn-disabled {
  border-radius: 10px;
  border: 1px solid var(--Neutral-300, #B0B0B0);
}

.btn-secundario {
  display: flex;
  width: 150px;
  height: 26px;
  padding: 6px 10px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  border: 1px solid var(--Neutral-200, #D1D1D1);
  background: var(--Neutral-150, #F3F3F3);
  cursor: pointer;
  transition: background 0.2s ease;
  font-size: 12px;
}

.btn-secundario:hover {
  background: #ECECEC;
}

.fichaje-cards-contenedor {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  gap: 20px;
  flex-wrap: nowrap;
}

.fichaje-column {
  flex: 1 1 33.3333%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}

.user-status-widget {
  background-color: #FAFAFA;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid #E7E7E7;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  height: 44px;
  width: 100%;
  box-sizing: border-box;
}

.user-status-name {
  color: var(--Neutral-600, #565656);
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}

.user-status-state {
  color: var(--Neutral-500, #6D6D6D);
  font-family: Roboto;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 1px;
}

.status-activo {
  background-color: #B993EA;
}

.status-pausa {
  background-color: #FFC107;
}

.status-inactivo {
  background-color: #9E9E9E;
}

.status-vacaciones {
  background-color: #2196F3;
}

.status-baja {
  background-color: #F44336;
}

/* WIDGET TIEMPO TRABAJADO (HISTORIAL) - ESTILOS COMENTADOS PARA FUTURA ELIMINACIÓN */
/*
.historial-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-self: stretch;
  height: 100%;
  background: #FFFFFF;
  border-radius: 12px;
  border: 1px solid #E7E7E7;
  overflow: hidden;
}

.historial-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  gap: 12px;
  background: #FAFAFA;
  border-bottom: 1px solid #E7E7E7;
}

.historial-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 16px;
  gap: 0;
  background: #FFFFFF;
  overflow: hidden;
}

.historial-titulo {
  color: #424242;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.historial-fecha {
  font-size: 13px;
  margin: 0;
  text-align: left;
  color: #757575;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
}

.historial-estado {
  font-size: 14px;
  color: #333;
}

.historial-switch {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: stretch;
  justify-content: flex-start;
  gap: 8px;
  overflow: hidden;
  min-height: 0;
}

.historial-switch > div {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.historial-switch input[type='checkbox'] {
  transform: scale(1.5);
  cursor: pointer;
}
*/
/* FIN WIDGET TIEMPO TRABAJADO (HISTORIAL) ESTILOS */

.icono-btn {
  width: 24px;
  height: 24px;
  margin-right: 0;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
  aspect-ratio: 1/1;
}

.icono-btn-secu {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.btn-volver {
  display: flex;
  align-items: center;
  color: var(--Neutral-300, #B0B0B0);
  font-family: Roboto;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px 20px;
  border-radius: 4px;
  width: 550px;
  height: 20px;
  flex-shrink: 0;
}

.fichaje-icono-tipo {
  display: flex;
  align-items: center; 
  gap: 6px;        
}


.marco-exterior {
  background-color: #FFFFFF;
  padding: 8px;
  border-radius: 10px;
  border: 1px solid #E7E7E7;
  min-height: 200px;
  height: auto;
  width: 100%;
  box-sizing: border-box;
}

.marco-interior {
  background-color: #FFFFFF;
  padding: 12px;
  border-radius: 18px;
  background: #FFFFFF;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  height: 100%;
  justify-content: center;
}
.header-linea {
  width: 100%;
  max-width: 100vw;
  padding: 16px 32px;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}

.header-titulo {
  color: var(--Primary-950, var(--v-primaryDark-base));
  font-family: var(--font-family-text-font-display, Roboto);
  font-size: var(--font-size-text-size-title-h3, 20px);
  font-style: normal;
  font-weight: var(--font-weight-text-weight-bold, 700);
  line-height: var(--font-line-height-text-size-title-h3, 24px); 
  letter-spacing: var(--font-letter-spacing-text-lineheight-heading, 0.5px);
}

.header-acciones {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  flex-grow: 1;
}

.marco-chico {
  display: flex;
  height: 42px;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  background: var(--Neutral-100, #F3F3F3);
}

.cuerpo-contenido {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 20px;
  box-sizing: border-box;
  width: 100%;
}

.fichaje-cards-contenedor > .fichaje-column {
  flex: 0 0 auto;
  width: 400px;
  min-width: 360px;
}

.fichaje-cards-contenedor > .center-column {
  flex: 0 0 auto;
  width: 300px;
  min-width: 270px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.fichaje-cards-contenedor > .right-column {
  flex: 1 1 auto;
  min-width: 360px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.center-column > .tiempo-trabajado-widget {
  flex: 1;
}

.right-column > .notifications-widget {
  flex: 1;
}

/* WIDGET TIEMPO TRABAJADO (HISTORIAL) - COMENTADO PARA FUTURA ELIMINACIÓN */
/*
.right-column > .historial-card {
  height: 320px;
  flex-shrink: 0;
}

.mensaje-sin-fichaje {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  text-align: center;
  gap: 12px;
  padding: 48px 20px;
  box-sizing: border-box;
}

.imagen-fichaje {
  width: 48px;
  height: 48px;
  aspect-ratio: 1/1;
  color: #D1D1D1;
}

.mensaje-buenos-dias {
  color: #424242;
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  margin: 0;
}

.mensaje-no-fichado {
  color: #9E9E9E;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
}
*/
/* FIN WIDGET TIEMPO TRABAJADO (HISTORIAL) */

.fichaje-list {
  padding: 0;
  list-style: none;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Transiciones para el fichaje */
.fichaje-enter-active {
  transition: all 0.3s ease-out;
}

.fichaje-enter {
  opacity: 0;
  transform: translateY(10px);
}

.fichaje-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.fichaje-item {
  border-radius: 8px;
  border: 1px solid #F3F3F3;
  display: flex;
  width: 100%;
  min-height: 45px;
  padding: 12px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  box-sizing: border-box;
  background: #FAFAFA;
  transition: all 0.2s ease;
}

.fichaje-item:hover {
  background: #F3F3F3;
  border-color: #E7E7E7;
}

.fichaje-item__hora {
  width: 37px;
  color: var(--Neutral-600, #565656);
  font-family: var(--Static-Title-Small-Font, Roboto);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: var(--Static-Title-Small-Line-Height, 20px); 
  letter-spacing: var(--Static-Title-Small-Tracking, 0.1px);
}

.fichaje-item__tipo {
  display: flex;
  min-width: 149px;
  flex: 1;
  height: 20px;
  flex-direction: column;
  justify-content: center;
  color: var(--Neutral-400, #888);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: var(--Static-Label-Medium-Line-Height, 16px);
}
.scroll-historial-clocks {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.scroll-historial-clocks::-webkit-scrollbar {
  width: 6px;
}
.scroll-historial-clocks::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.scroll-historial-clocks::-webkit-scrollbar-track {
  background-color: transparent;
}
.boton-modificar {
  display: flex;
  height: 32px;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 10px;
  background: var(--Neutral-100, #F3F3F3);
}
.boton-modificar:hover {
  background: #cacaca;
  transform: translateY(-1px);
}
.fichaje-item__content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.fichaje-info {
  display: flex;
  flex-direction: column;
}


.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}

.left-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 8px;
}

.page-title {
  margin-top: 6px;
  margin-left: 20px;
  font-size: 22px;
  font-weight: 600;
  color: var(--v-primaryDark-base);
}

.page-title-home {
  margin-top: 14px;
  margin-left: 14px;
  font-size: 20px;
  font-weight: 600;
  color: var(--v-primaryDark-base);
}

.right-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Dropdown Mi perfil */
.profile-dropdown {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  background: var(--Primary-700, #7339B7);
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.profile-dropdown:hover {
  background: #5E2D91;
}

.profile-dropdown__text {
  color: white;
  font-size: 12px;
  font-weight: 500;
}

.profile-dropdown__arrow {
  color: white !important;
  margin-left: 4px;
}

.profile-dropdown__menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 150px;
  z-index: 100;
  overflow: hidden;
}

.profile-dropdown__item {
  padding: 12px 16px;
  font-size: 12px;
  color: #4A4A4A;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.profile-dropdown__item:hover {
  background: #F2EBFC;
  color: #7339B7;
}

.btn-primario {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  font-weight: 600;
  font-size: 14px;
  border: 1px solid var(--v-primary-base);
  background: #F9F6FE;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  height: 42px;
}

.btn-primario:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-primario.btn-refresh {
  background: transparent;
  border: none;
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
}

.btn-primario.btn-refresh:hover {
  background: rgba(0, 0, 0, 0.05);
}

.btn-primario.btn-refresh:disabled {
  background: transparent;
  opacity: 0.5;
  cursor: not-allowed;
}

.header-separator {
  width: calc(100% + 40px);
  margin-left: -20px;
  border: none;
  border-top: 1px solid #ccc;
  margin-top: 1px;
  margin-bottom: 0;
}

.header-separator-1 {
  width: calc(100% + 40px);
  margin-left: -20px;
  border: none;
  border-top: 1px solid #ccc;
  margin-top: 1px;
  margin-bottom: 20px;
}

.acciones-secundarias {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  margin: 12px 0;
  padding: 0 12px;
  box-sizing: border-box;
  gap: 8px;
}
.btn-secundario-1 {
  display: flex;
  width: 150px;
  height: 26px;
  padding: 6px 10px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  border: 1px solid var(--Neutral-200, #D1D1D1);
  background: var(--Neutral-150, #F3F3F3);
  cursor: pointer;
  transition: background 0.2s ease;
  font-size: 12px;
}

.btn-secundario-1:hover {
  background: #ECECEC;
}

.btn-refresh {
  display: flex;
  width: 26px;
  height: 26px;
  padding: 3px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-right: 14px;
  margin-top: 14px;
}

.username {
  color: var(--Neutral-400, #888);
  text-align: center;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: var(--Static-Title-Large-Line-Height, 28px); 
  letter-spacing: var(--Static-Title-Large-Tracking, 0);
}

.fichaje-item {
  padding: 8px 12px;
  border-bottom: 1px solid #ddd;
}

.boton-modificar {
  background-color: transparent;
  border: 1px solid var(--v-primary-base);
  color: var(--v-primary-base);
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.2s ease;
}

.boton-modificar:hover {
  background-color: var(--v-primary-base);
  color: white;
}

@media (min-width: 1025px) {
  .acciones-secundarias button {
    flex: 0 1 auto;
    margin-right: 12px;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .btn-fichar-in,
  .btn-fichar-out {
    width: 33%;
    padding: 12px;
    font-size: 14px;
  }

  .btn-secundario,
  .btn-secundario-1 {
    font-size: 13px;
    padding: 6px 10px;
    width: auto;
    min-width: 80px;
  }

  .acciones-secundarias {
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-start;
    margin: 12px;
  }

  .acciones-secundarias button {
    flex: 1 1 auto;
    max-width: 120px;
    font-size: 13px;
    padding: 6px 10px;
  }

  .fichaje-cards-contenedor {
    flex-wrap: wrap;
    gap: 20px;
  }

  .fichaje-column,
  .historial-card {
    flex: 1 1 100%;
    height: auto;
  }

  .marco-exterior {
    height: auto;
  }
}

@media (max-width: 767px) {
  .fichaje-cards-contenedor {
    flex-direction: column;
    gap: 16px;
    padding: 0 12px;
  }

  .fichaje-cards-contenedor > .fichaje-column {
    order: 1;
    width: 100%;
  }

  .fichaje-cards-contenedor > .historial-card {
    order: 2;
    width: 100%;
    height: auto;
  }

  .marco-exterior {
    height: auto;
  }

  .header-title {
    font-size: 18px;
    margin-left: 12px;
  }

  .btn-fichar-in,
  .btn-fichar-out {
    font-size: 14px;
    padding: 12px;
  }

  .historial-header {
    padding: 10px 12px;
    flex-direction: column;
    align-items: flex-start;
  }

  .historial-fecha,
  .historial-titulo {
    font-size: 14px;
  }

  .fichaje-item {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .fichaje-item__tipo {
    font-size: 12px;
    width: auto;
  }

  .fichaje-item__hora {
    font-size: 12px;
  }

  .acciones-secundarias {
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-start;
    margin: 12px;
  }

  .acciones-secundarias button {
    flex: 1 1 auto;
    max-width: 120px;
    font-size: 13px;
    padding: 6px 10px;
  }

  .btn-secundario,
  .btn-secundario-1 {
    width: auto;
    min-width: 80px;
    max-width: 120px;
    font-size: 13px;
    padding: 6px 10px;
  }
}

/* COMENTADO - Estilos del Widget de Calendario (widget desactivado)
.calendar-widget {
  margin-top: 0;
  background: #FFFFFF;
  border-radius: 12px;
  border: 1px solid #E7E7E7;
  overflow: hidden;
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #FAFAFA;
  border-bottom: 1px solid #E7E7E7;
}

.calendar-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.calendar-month {
  font-size: 16px;
  font-weight: 600;
  color: #424242;
}

.calendar-year {
  font-size: 12px;
  color: #757575;
}

.btn-calendar-nav {
  background: transparent;
  border: none;
  color: #7339B7;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}

.btn-calendar-nav:hover {
  background: rgba(115, 57, 183, 0.1);
}

.calendar-body {
  padding: 16px;
}

.calendar-weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
  margin-bottom: 8px;
}

.calendar-weekday {
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  color: #757575;
  padding: 8px 4px;
}

.calendar-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
}

.calendar-day {
  aspect-ratio: 1;
  border-radius: 8px;
  border: 1px solid #F3F3F3;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.2s ease;
  cursor: pointer;
}

.calendar-day:hover:not(.calendar-day-empty) {
  border-color: #D1D1D1;
}

.calendar-day-empty {
  background: transparent;
  border: none;
  cursor: default;
}

.calendar-day-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px;
  position: relative;
}

.calendar-day-number {
  font-size: 13px;
  font-weight: 500;
  color: #424242;
  margin-bottom: 2px;
}

.calendar-day-hours-container {
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: center;
  width: 100%;
}

.calendar-day-expected-hours {
  font-size: 11px;
  color: #4CAF50;
  font-weight: 700;
  background: rgba(76, 175, 80, 0.15);
  padding: 3px 6px;
  border-radius: 4px;
  border: 1px solid rgba(76, 175, 80, 0.3);
}

.calendar-day-hours {
  font-size: 11px;
  color: #7339B7;
  font-weight: 700;
  background: rgba(115, 57, 183, 0.1);
  padding: 3px 6px;
  border-radius: 4px;
  border: 1px solid rgba(115, 57, 183, 0.2);
}

.calendar-day-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vacation-badge {
  background: #4CAF50;
}

.absence-badge {
  background: #FF9800;
}

.calendar-day-today {
  border: 2px solid #7339B7;
  background: rgba(115, 57, 183, 0.05);
}

.calendar-day-today .calendar-day-number {
  color: #7339B7;
  font-weight: 700;
}

.calendar-day-weekend {
  background: #FAFAFA;
}

.calendar-day-weekend .calendar-day-number {
  color: #9E9E9E;
}

.calendar-day-vacation {
  background: rgba(76, 175, 80, 0.1);
  border-color: #4CAF50;
}

.calendar-day-vacation .calendar-day-number {
  color: #4CAF50;
  font-weight: 600;
}

.calendar-day-absence {
  background: rgba(255, 152, 0, 0.1);
  border-color: #FF9800;
}

.calendar-day-absence .calendar-day-number {
  color: #FF9800;
  font-weight: 600;
}

.calendar-legend {
  display: flex;
  justify-content: space-around;
  padding: 12px 16px;
  background: #FAFAFA;
  border-top: 1px solid #E7E7E7;
  gap: 8px;
  flex-wrap: wrap;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.legend-color {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  flex-shrink: 0;
}

.legend-text {
  font-size: 11px;
  color: #757575;
  font-weight: 500;
}
*/

/* Estilos del Widget de Notificaciones */
.notifications-widget {
  background: #FFFFFF;
  border-radius: 10px;
  border: 1px solid #E7E7E7;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.notifications-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  background: #FAFAFA;
  border-bottom: 1px solid #E7E7E7;
}

.notifications-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #424242;
}

.btn-mark-all-read {
  background: transparent;
  border: none;
  color: #7339B7;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 5px;
  transition: background-color 0.2s ease;
}

.btn-mark-all-read:hover {
  background: rgba(115, 57, 183, 0.1);
}

.notifications-body {
  max-height: 100%;
  overflow-y: auto;
  flex: 1;
}

.notifications-list {
  display: flex;
  flex-direction: column;
}

.notification-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border-bottom: 1px solid #F3F3F3;
  transition: background-color 0.2s ease;
  cursor: default;
}

.notification-item:hover {
  background-color: #FAFAFA;
}

.notification-item:last-child {
  border-bottom: none;
}

.notification-icon {
  flex-shrink: 0;
  padding-top: 2px;
}

.notification-dot {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.notification-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.notification-title {
  font-size: 12px;
  font-weight: 600;
  color: #424242;
  line-height: 1.4;
}

.notification-message {
  font-size: 11px;
  color: #757575;
  line-height: 1.5;
}

.notification-time {
  font-size: 10px;
  color: #9E9E9E;
  margin-top: 3px;
}

.btn-dismiss {
  flex-shrink: 0;
  background: transparent;
  border: none;
  color: #BDBDBD;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-dismiss:hover {
  background: #F3F3F3;
  color: #757575;
}

.notifications-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 14px;
  gap: 10px;
}

.notifications-empty p {
  font-size: 12px;
  color: #9E9E9E;
  margin: 0;
}

/* Scrollbar personalizada para notificaciones */
.notifications-body::-webkit-scrollbar {
  width: 6px;
}

.notifications-body::-webkit-scrollbar-track {
  background: #F5F5F5;
}

.notifications-body::-webkit-scrollbar-thumb {
  background: #D1D1D1;
  border-radius: 3px;
}

.notifications-body::-webkit-scrollbar-thumb:hover {
  background: #BDBDBD;
}

/* Estilos del Widget de Tiempo Trabajado (nuevo diseño) */
.tiempo-trabajado-widget {
  background: #FFFFFF;
  border-radius: 10px;
  border: 1px solid #E7E7E7;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 200px;
}

.tiempo-trabajado-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  background: #FAFAFA;
  border-bottom: 1px solid #E7E7E7;
  min-height: 44px;
  box-sizing: border-box;
}

.ubicacion-label {
  font-size: 12px;
  font-weight: 500;
  color: #424242;
}

.ubicacion-selector {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 3px;
}

.ubicacion-selector .ubicacion-text {
  font-size: 12px;
  font-weight: 700;
  color: #4F4F4F;
}

.ubicacion-icon {
  width: 14px;
  height: 14px;
  margin-right: 6px;
}

.tiempo-trabajado-body {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 10px 14px 18px 14px;
  flex: 1;
  gap: 0;
}

/* Fecha y hora en header */
.date-text {
  font-size: 12px;
  font-weight: 500;
  color: #757575;
}

.date-inside-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 10px;
  border-bottom: 1px solid #E7E7E7;
  margin-left: -14px;
  margin-right: -14px;
  padding-left: 14px;
  padding-right: 14px;
}

.time-text {
  font-size: 12px;
  font-weight: 500;
  color: #888888;
}

.current-time-text {
  font-size: 14px;
  font-weight: 600;
  color: #757575;
}

/* Estilos simplificados para franjas horarias */
.simple-slots {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.simple-slot {
  display: flex;
  align-items: center;
  gap: 10px;
}

.slot-icon {
  width: 22px;
  height: 22px;
}

.simple-slot-time {
  font-size: 15px;
  font-weight: 500;
  color: #424242;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 3px;
}

.slot-now {
  color: #424242;
}

.slot-now-icon {
  width: 12px;
  height: 12px;
  margin-left: 3px;
}

.slot-now-icon-pause {
  filter: brightness(0) saturate(100%) invert(85%) sepia(47%) saturate(497%) hue-rotate(358deg) brightness(97%) contrast(90%);
}

.simple-slot-duration {
  font-size: 14px;
  font-weight: 600;
  color: #454545;
}

.simple-slot-duration.duration-pause {
  color: #838383;
}

.simple-slots-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 6px;
}

.simple-slots-empty span {
  font-size: 12px;
  color: #9E9E9E;
}

/* Estilos legacy para círculo de progreso (mantener por si se reutiliza) */
.progress-circle-container {
  position: relative;
  width: 120px;
  height: 120px;
  flex-shrink: 0;
}

.stat-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-icon.trabajado {
  background: rgba(115, 57, 183, 0.1);
}

.stat-icon.pausa {
  background: rgba(255, 193, 7, 0.15);
}

.stat-icon.objetivo {
  background: rgba(76, 175, 80, 0.1);
}

.stat-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
}

.stat-value {
  font-size: 14px;
  font-weight: 600;
  color: #424242;
  line-height: 1.2;
}

.stat-label {
  font-size: 10px;
  color: #9E9E9E;
  font-weight: 500;
  text-align: center;
}

/* COMENTADO - Estilos del Widget de Horario Semanal (widget desactivado)
.schedule-widget {
  margin-top: 12px;
  background: #FFFFFF;
  border-radius: 12px;
  border: 1px solid #E7E7E7;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.schedule-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #FAFAFA;
  border-bottom: 1px solid #E7E7E7;
}

.schedule-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #424242;
}

.schedule-body {
  padding: 12px;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.schedule-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  justify-content: space-evenly;
}

.schedule-day-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #FAFAFA;
  border-radius: 8px;
  border: 1px solid #F3F3F3;
  transition: all 0.2s ease;
}

.schedule-day-item:hover {
  background: #F3F3F3;
  border-color: #E7E7E7;
}

.schedule-day-today {
  background: rgba(115, 57, 183, 0.05);
  border: 2px solid #7339B7;
}

.schedule-day-today .schedule-day-name {
  color: #7339B7;
  font-weight: 700;
}

.schedule-day-name {
  font-size: 14px;
  font-weight: 600;
  color: #424242;
  min-width: 80px;
}

.schedule-day-hours {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  justify-content: flex-end;
}

.schedule-time {
  font-size: 13px;
  font-weight: 600;
  color: #565656;
  background: #FFFFFF;
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid #E7E7E7;
}

.schedule-break {
  font-size: 12px;
  color: #F57C00;
  font-weight: 600;
  background: rgba(255, 152, 0, 0.1);
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid rgba(255, 152, 0, 0.3);
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 8px;
}

.schedule-day-off {
  font-size: 13px;
  color: #9E9E9E;
  font-style: italic;
  flex: 1;
  text-align: right;
}

.schedule-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 20px;
  gap: 12px;
}

.schedule-empty p {
  font-size: 14px;
  color: #9E9E9E;
  margin: 0;
}
*/

/* Estilos para la fila inferior con tres widgets */
.bottom-widgets-row {
  display: flex;
  gap: 32px;
  width: 100%;
  padding: 0 32px;
  margin-top: 32px;
  box-sizing: border-box;
}

/* WIDGET TIEMPO TRABAJADO (HISTORIAL) - COMENTADO PARA FUTURA ELIMINACIÓN */
/*
.bottom-widgets-row > .historial-card {
  flex: 1;
  min-width: 0;
  height: 580px;
  overflow: hidden;
}
*/

/* COMENTADO - referencias a widgets desactivados
.bottom-widgets-row > .calendar-widget,
.bottom-widgets-row > .schedule-widget {
  flex: 1;
  min-width: 0;
  height: 580px;
  overflow: hidden;
}

.bottom-widgets-row > .schedule-widget {
  margin-top: 0;
}
*/

/* ========== ESTILOS RESUMEN DÍA EN UNA LÍNEA ========== */
/* WIDGET TIEMPO TRABAJADO (HISTORIAL) - COMENTADO PARA FUTURA ELIMINACIÓN */
/*
.historial-lista {
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  max-height: 100%;
  padding: 8px 0;
}

.historial-switch > .resumen-dia-container,
.historial-lista > .resumen-dia-container {
  flex: 0 0 auto !important;
  min-height: auto !important;
  overflow: visible !important;
}
*/

/* WIDGET TIEMPO TRABAJADO (HISTORIAL) - COMENTADO PARA FUTURA ELIMINACIÓN */
/*
.resumen-dia-container {
  display: flex !important;
  flex-direction: column !important;
  gap: 4px;
  padding: 8px 16px;
  margin: 8px 16px;
  background: #FAFAFA;
  border-radius: 8px;
  border: 1px solid #F3F3F3;
  flex: 0 0 auto !important;
  width: calc(100% - 32px);
  box-sizing: border-box;
}

.resumen-dia-linea {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start;
  gap: 12px;
  flex-wrap: nowrap;
}

.entrada-info,
.salida-info,
.total-info {
  display: flex;
  align-items: center;
  gap: 6px;
}

.resumen-dia-linea .label {
  font-size: 14px;
  font-weight: 500;
  color: #888;
}

.resumen-dia-linea .hora {
  font-size: 18px;
  font-weight: 700;
  color: #565656;
}

.resumen-dia-linea .hora.pendiente {
  color: #D1D1D1;
}

.separador-flecha {
  margin: 0 4px;
}

.separador-vertical {
  width: 1px;
  height: 24px;
  background: #D1D1D1;
  margin: 0 8px;
}

.total-info .total-valor {
  font-size: 18px;
  font-weight: 700;
  color: #7339B7;
}

.resumen-fecha {
  font-size: 13px;
  color: #757575;
  font-family: Roboto;
  font-weight: 500;
}
*/
/* FIN WIDGET TIEMPO TRABAJADO (HISTORIAL) ESTILOS */

/* SNACKBAR FICHAJE COMPLETADO */
.snackbar-success {
  position: fixed;
  bottom: 120px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
}

.snackbar-success::v-deep .v-snack__wrapper {
  background: #4CAF50;
  border-radius: 24px;
  min-width: auto;
  margin: 0 auto;
}

.snackbar-success::v-deep .v-snack__content {
  padding: 12px 24px;
  justify-content: center;
  text-align: center;
}

.snackbar-success-text {
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  display: block;
  width: 100%;
}
/* FIN SNACKBAR FICHAJE COMPLETADO */

/* POPUP CONFIRMACIÓN FINALIZAR FICHAJE */
.confirm-dialog-centered {
  display: flex;
  align-items: center;
  justify-content: center;
}

.confirm-popup-container {
  background: #FFFFFF;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  padding: 40px 44px;
  text-align: center;
  max-width: 520px;
  width: 100%;
}

.confirm-popup-title {
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #1A1A1A;
  margin: 0 0 16px 0;
  line-height: 1.3;
}

.confirm-popup-description {
  color: var(--Neutral-500, #6D6D6D);
  text-align: center;
  font-family: var(--Title-Small-Font, Roboto);
  font-size: var(--Title-Small-Size, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: var(--Title-Small-Line-Height, 20px);
  letter-spacing: var(--Title-Small-Tracking, 0.1px);
  margin: 0 0 32px 0;
  max-width: 380px;
  margin-left: auto;
  margin-right: auto;
}

.confirm-popup-buttons {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.confirm-btn-secondary {
  padding: 12px 24px;
  border-radius: 8px;
  border: 0.5px solid var(--Neutral-700, #4F4F4F);
  background: var(--Neutral-50-CC, rgba(249, 249, 249, 0.80));
  color: var(--Neutral-950, #262626);
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
  transition: all 0.2s ease;
}

.confirm-btn-secondary:hover {
  background: rgba(249, 249, 249, 1);
}

.confirm-btn-primary {
  padding: 12px 24px;
  border-radius: 8px;
  border: 0.5px solid var(--Error-700, #A70D0D);
  background: var(--Error-150, rgba(255, 196, 196, 0.30));
  color: var(--Error-950, #4C0303);
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
  transition: all 0.2s ease;
}

.confirm-btn-primary:hover {
  background: rgba(255, 196, 196, 0.50);
}

</style>
